module.exports = __webpack_public_path__ + "static/img/image048.faf684e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image048.png
// module id = tkiJ
// module chunks = 1